import { createFileRoute } from '@tanstack/react-router';
import { MasterObligationDocumentAnalyser } from './MasterObligationDocumentAnalyser';

export const Route = createFileRoute(
    '/admin-console/platform-content/obligations/library/details/$id/document-analyser',
)({
    component: () => <MasterObligationDocumentAnalyser />,
});
